import {
  IconDefinition,
  faPencilRuler,
  faQuestionCircle,
  faSackXmark
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';

import Tooltip from '@/ui/components/Tooltip';

import { BillingReportRow } from '../../types';
import { isBlank } from '../../utils/isBlank';

interface Indicator {
  icon: IconDefinition;
  color: string;
  tooltip: (data: BillingReportRow) => string;
}

const INDICATORS: Record<string, Indicator> = {
  non_billable: {
    icon: faSackXmark,
    color: 'text-red-600',
    tooltip: () => {
      return `Marked as Non-Billable`;
    }
  },

  has_edits: {
    icon: faPencilRuler,
    color: 'text-green-600',
    tooltip: () => {
      return 'Has Edits';
    }
  }
};

const IndicatorsGridCell = ({ data }: { data?: BillingReportRow }): JSX.Element | null => {
  if (!data || isBlank(data.indicators)) {
    return null;
  }

  return (
    <span className="flex items-center h-full">
      {(data.indicators || []).map((indicatorSlug, index) => {
        const indicator = INDICATORS[indicatorSlug];
        return (
          <Tooltip tooltipContent={indicator.tooltip(data)} key={`index-${indicatorSlug}-${index}`}>
            <span className="inline-flex items-center">
              <FontAwesomeIcon
                icon={indicator.icon || faQuestionCircle}
                className={`mr-2 align-middle ${indicator.color || 'text-gray-600'}`}
              />
            </span>
          </Tooltip>
        );
      })}
    </span>
  );
};

export default IndicatorsGridCell;
